
import { supabase } from '@/integrations/supabase/client';

interface ToggleResearchFavoriteParams {
  researchId: string;
  isFavorited: boolean;
}

export class ResearchFavoriteService {
  static async toggleFavorite({
    researchId,
    isFavorited,
  }: ToggleResearchFavoriteParams): Promise<void> {
    try {
      // Get current user
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError || !user) {
        throw new Error('Authentication required to toggle favorite');
      }

      if (isFavorited) {
        // Remove favorite - the database trigger will automatically update the count
        const { error } = await supabase
          .from('research_favorites')
          .delete()
          .eq('research_id', researchId)
          .eq('user_id', user.id);

        if (error) throw error;
      } else {
        // Add favorite - the database trigger will automatically update the count
        const { error } = await supabase
          .from('research_favorites')
          .insert({
            research_id: researchId,
            user_id: user.id,
          });

        if (error) throw error;
      }

    } catch (error) {
      console.error('Error toggling research favorite:', error);
      throw error;
    }
  }
}
